export const SBL_LOGIN_RESPONSE = 'SBL_LOGIN_RESPONSE';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js